import { connect } from 'react-redux';
import {
  getMatches, goToProfile, getUsers, getProfilePhoto,
} from '../../actions';
import Matches from './component';

export const mapStateToProps = state => (
  {
    user: state.user,
    users: state.feed.users,
    usersRecip: state.matches.usersRecip,
    usersNoRecip: state.matches.usersNoRecip,
    numRequests: state.matches.requests,
  }
);

export default connect(mapStateToProps, {
  getMatches, goToProfile, getUsers, getProfilePhoto,
})(Matches);
